import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { PostHogProvider } from 'posthog-js/react';
const options = {
  api_host: 'https://us.i.posthog.com',
  defaults: '2025-05-24'
};
render(<PostHogProvider apiKey="phc_4cBjZ0ovPiViLpt2jFhcOGcAyS0SaIct5H5TjJMzQJu" options={options} data-id="element-531" data-mp="219ee87e5t0n4">

    <App data-id="element-532" data-mp="26a26ewe4jnix" />
  </PostHogProvider>, document.getElementById('root'));